import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import NewPurchase from "../../components/purchase/NewPurchase";
import { useLocation } from "react-router-dom";

const NewpurchasePage = () => {
    const { state } = useLocation();
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            {state?.id ? (
                                <Navbar content="EDIT PURCHASE" />
                            ) : (
                                <Navbar content="NEW PURCHASE" />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <NewPurchase />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NewpurchasePage;
